import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=11f7e213&scoped=true&"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts&"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=11f7e213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7e213",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11f7e213')) {
      api.createRecord('11f7e213', component.options)
    } else {
      api.reload('11f7e213', component.options)
    }
    module.hot.accept("./LanguageSwitcher.vue?vue&type=template&id=11f7e213&scoped=true&", function () {
      api.rerender('11f7e213', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LanguageSwitcher.vue"
export default component.exports